import { Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter, map, startWith } from 'rxjs';
import { HeaderNavbarComponent } from '../header-navbar/header-navbar.component';

@Component({
  selector: 'app-logged-page',
  imports: [HeaderNavbarComponent, RouterOutlet],
  templateUrl: './logged-page.component.html',
  styleUrl: './logged-page.component.scss',
})
export class LoggedPageComponent {
  private readonly router = inject(Router);

  private readonly currentUrl = toSignal(
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map((event) => event.urlAfterRedirects),
      startWith(this.router.url),
    ),
    { initialValue: this.router.url },
  );

  protected readonly showAllProjectsAction = computed(() => {
    const url = this.currentUrl() ?? '';
    return (
      url.startsWith('/projects/create') ||
      url.startsWith('/projects/edit') ||
      url.startsWith('/profile')
    );
  });

  protected readonly actionLabel = computed(() =>
    this.showAllProjectsAction() ? 'Back to projects list' : null,
  );

  protected readonly actionLink = computed(() =>
    this.showAllProjectsAction() ? ['/projects'] : null,
  );
}
